import React  from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import ProtectedRoute from './components/protected-route'

import { 
    Home, 
    TalentDashboard,
    About,
    WorldClassAI,
    JoinTalentNetwork,

    TalentPresignupPage,
    TalentSignup,
    TalentProfile, 
    TalentProjects, 
    Assessments,
    Courses,

    InputForm,
    ServiceResults,

    BusinessProfile, 
    BusinessProjects, 
    BusinessProjectsList,     
    JobPosts,
    Scope, 
    Match
} from './pages/index';

import Loading from './components/loading';


function App() {
    const { isLoading } = useAuth0();

    if (isLoading) {
        return <Loading />;
    }

    return ( 
        <div> 
            <Router basename="/">    
                <Switch>

                InputForm
                <Route path="/" exact component={InputForm} /> 

                    {/* Main Website Pages
                    <Route path="/" exact component={Home} /> 
                    <ProtectedRoute path="/TalentDashboard" exact component={TalentDashboard} /> 
                    <Route path="/About" component ={About} />
                    <Route path="/WorldClassAI" component ={WorldClassAI} />
                    <Route path="/JoinTalentNetwork" component ={JoinTalentNetwork} />

                    {/* Talent Pages */}
                    {/* <Route path="/info" component ={TalentSignup} />
                    <ProtectedRoute path="/TalentProfile" component ={TalentProfile} />
                    <Route path="/assessments" component ={Assessments} />
                    <Route path="/courses" component ={Courses} />
                    <Route path="/TalentProjects" component ={TalentProjects} />
                    <Route path="/TalentPresignup" component = {TalentPresignupPage}/> */}

                    {/* Partner Pages */}
                    {/* <Route path="/BusinessProfile" component ={BusinessProfile} />
                    <Route path="/BusinessProjects" component ={BusinessProjects} />
                    <Route path="/BusinessProjectsList" component ={BusinessProjectsList} /> */}

                    {/* ATS Pages */}
                    {/* <Route path="/scope" component ={Scope} />
                    <Route path="/match" component ={Match} />

                    <Route path="/JobPosts" component ={JobPosts} /> */}

                    {/* new empolyer pages */}
                    {/* <Route path="/service" component={InputForm}/>
                    <Route path="/service-result" component={ServiceResults}/> */} */}

                </Switch>
            </Router>
        </div> 
    ); 
}


export default App;
